import { render } from "./ScheduleDashboard.vue?vue&type=template&id=38408086&scoped=true"
import script from "./ScheduleDashboard.vue?vue&type=script&lang=js"
export * from "./ScheduleDashboard.vue?vue&type=script&lang=js"

import "./ScheduleDashboard.vue?vue&type=style&index=0&id=38408086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38408086"]])

export default __exports__